/* eslint-disable @typescript-eslint/no-explicit-any */
interface Vehicle {
  vehicleType?: string;
  offering?: string | null;
  msrp?: number;
  [key: string]: any;
}

export const isNewVehicle = (vehicle: Vehicle | null | undefined) => {
  return vehicle?.offering?.toLowerCase() === 'new' ||
    (vehicle?.msrp && vehicle?.msrp > 0) ||
    vehicle?.vehicleType?.toLowerCase() === 'new'
    ? true
    : false;
};
